import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
// import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries"; // Poolcorp Custom Code
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

/* Poolcorp Custom Code */
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getHeader } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import { getPageLinkByNodeId, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import getProp from "@insite/mobius/utilities/getProp";
import NavigationDrawer from "@store/Overrides/Components/NavigationDrawer";
import { MappedLink } from "@store/Overrides/Widgets/Header/MainNavigation";
import { getStoreSession, getStoreSettingsCollection } from "@store/Store/Context/ContextSelectors";
import { siteWidthStyles, transitionHoverStyles } from "@store/theme/common/mixins";
import { StoreThemeButtonProps, themeButtonStyles } from "@store/theme/common/mixins";
import { COMMON, TYPOGRAPHY } from "@store/theme/design";
import breakpointMediaQueries, { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import last from "lodash/last";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    /* Poolcorp Custom Code */
    const settings = getStoreSettingsCollection(state);
    const session = getStoreSession(state);
    /* Poolcorp Custom Code */

    const mainNavFields = getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Header/MainNavigation";
    })?.fields; // Poolcorp Custom Code

    return {
        links: mainNavFields?.links as MappedLink[],
        isSignedIn: state.context.session.userName && !getCurrentUserIsGuest(state),
        rememberMe: state.context.session.rememberMe,
        // Poolcorp Custom Code
        disablePickupBranchSelection: settings.poolcorpSettings.disablePickupBranchSelectionByCountry,
        isFullfillmentMethodPickup: session.fulfillmentMethod === FulfillmentMethod.PickUp,
    };
};
const enum fields {
    middleLinks = "middleLinks",
    // Poolcorp Custom Code
    destination = "destination",
    openInNewWindow = "openInNewWindow",
    signedIn = "signedIn",
    overrideTitle = "overrideTitle",
    variant = "variant",
}

export interface LogoLinksSearchLinksModel {
    fields: {
        [fields.destination]: LinkFieldValue;
        [fields.signedIn]: boolean;
        [fields.openInNewWindow]: boolean;
        [fields.overrideTitle]: string;
        [fields.variant]: "primary" | "secondary" | "tertiary" | "quarternary" | "quinary" /* Poolcorp Custom Code */;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.middleLinks]: LogoLinksSearchLinksModel[]; // Poolcorp Custom Code
    };
}
/* Poolcorp Custom Code */

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    // Poolcorp Custom Code
    innerContainer: InjectableCss;
    linksWrapper?: InjectableCss;
    leftLinksWrapper?: InjectableCss;
    middleLink?: LinkPresentationProps;
    branchIndicatorWrapper?: InjectableCss;
    innerContainerSignedIn?: InjectableCss;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & PageProps; // Poolcorp Custom Code

/* Poolcorp Custom Code */
export const MOBILE_HEADER_HEIGHT = 50;
export const SMALLEST_HEADER_HEIGHT = 60;
export const LOGO_LINK_SEARCH_NAV = [MOBILE_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT, 80, 80, 90];
export const MAIN_NAV_HEIGHT = [null, MOBILE_HEADER_HEIGHT, 137, 137, 155];
/* Poolcorp Custom Code */

const innerContainerStyles = () => {
    return css`
        height: 100%;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        ${props =>
            breakpointMediaQueries(
                props.theme,
                [
                    null,
                    css`
                        max-width: none;
                        padding-right: 0;
                        padding-left: 0;
                    `,
                ],
                mediaOptions.max,
            )}
    `;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            height: ${MOBILE_HEADER_HEIGHT}px;
            transition: ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            justify-content: center;
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [{ values: [null, null, 80, null, 90], properties: ["height"], unit: "px" }],
                    mediaOptions.min,
                )}
            [data-contentid] & {
                height: auto;
            }
        `,
    },
    innerContainer: {
        css: css`
            ${siteWidthStyles()}
            ${innerContainerStyles()}
        `,
    },
    innerContainerSignedIn: {
        css: css`
            ${siteWidthStyles(undefined, 1800)}
            ${innerContainerStyles()}
        `,
    },
    logoWrapper: {
        css: css`
            margin-right: 0.75em;

            > div {
                display: flex;
                height: 100%;
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            flex-grow: 1;
            margin-right: 0.75em;
        `,
    },
    branchIndicatorWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 0.75em;
        `,
    },
    linksWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        null,
                        css`
                            height: 100%;
                        `,
                    ],
                    mediaOptions.max,
                )}

            > div {
                flex: 0 0 auto;
                width: auto;
                height: 100%;
                ${props =>
                    breakpointMediaQueries(
                        props.theme,
                        [
                            null,
                            null,
                            css`
                                margin-left: 0.75em;
                            `,
                        ],
                        mediaOptions.min,
                    )}

                &:first-child {
                    margin-left: 0;
                    display:flex;
                }
            }
        `,
    },
    leftLinksWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
        `,
    },
    linkListHidden: {
        css: css`
            margin-left: 0 !important;
        `,
    },
    middleLink: {
        css: css`
            line-height: 1;
            padding: 10px 12px;
            margin-left: 0.75em;
            ${transitionHoverStyles()}
        `,
        typographyProps: {
            weight: TYPOGRAPHY.weight.black,
            size: TYPOGRAPHY.size.smaller,
        },
    },
};

const LogoLinksSearch: React.FC<Props> = ({
    id,
    isSignedIn,
    links,
    // Poolcorp Custom Code
    // Poolcorp Custom Code - remove quickOrder props
    fields,
    rememberMe,
    disablePickupBranchSelection,
    isFullfillmentMethodPickup,
}) => {
    const [isSearchOpen, setIsSearchOpen] = React.useState(false);
    const [beginScrollTop, setBeginScrollTop] = React.useState(-1);
    const [currentScrollTop, setCurrentScrollTop] = React.useState(0);

    const isNotPickupBranchSelectionDisabled = !(disablePickupBranchSelection && isFullfillmentMethodPickup); // Poolcorp Custom Code

    const handleScroll = () => {
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        setCurrentScrollTop(scrollTop);
    };
    React.useEffect(() => {
        const searchInputHasFocus =
            document.activeElement?.getAttribute("data-test-selector") === "headerSearchInputTextField";
        if (currentScrollTop <= 50) {
            setIsSearchOpen(true);
        } else if (!searchInputHasFocus) {
            if ((beginScrollTop > -1 && Math.abs(currentScrollTop - beginScrollTop) > 100) || beginScrollTop === -1) {
                setIsSearchOpen(false);
                setBeginScrollTop(-1);
            }
        }
    }, [currentScrollTop]);
    React.useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }
        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return function cleanup() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    
    const middleLinks = fields.middleLinks ? useGetLinks(fields.middleLinks, o => o.fields.destination) : null;

    return (
        <StyledWrapper data-test-selector="LogoLinkSearchWrapper">
            {/* Poolcorp Custom Code */}
            <StyledWrapper {...logoLinksSearchStyles.container} data-test-selector="LogoLinkSearch">
                <StyledWrapper {...((isSignedIn || rememberMe) && isNotPickupBranchSelectionDisabled ? logoLinksSearchStyles.innerContainerSignedIn : logoLinksSearchStyles.innerContainer)}>
                    <Hidden below="md" data-test-selector="NavigationDrawerSticky">
                        <NavigationDrawer
                            links={links}
                        />
                    </Hidden>
                    <Hidden below="lg" {...logoLinksSearchStyles.logoWrapper} data-test-selector="LogoZoneSticky">
                        <Zone contentId={id} zoneName="Logo" />
                    </Hidden>
                    <Hidden below="md" above="md" {...logoLinksSearchStyles.logoWrapper} data-test-selector="LogoZoneStickySmaller">
                        <Zone contentId={id} zoneName="LogoSmaller" />
                    </Hidden>
                    {(isSignedIn || rememberMe) && isNotPickupBranchSelectionDisabled ?  (
                        <Hidden below="md" {...logoLinksSearchStyles.branchIndicatorWrapper}>
                            <Zone contentId={id} zoneName="BranchIndicator" />
                        </Hidden>
                    ) : null}
                    <Hidden below="md" {...logoLinksSearchStyles.searchMenuWrapper}>
                        <Zone contentId={id} zoneName="Search" />
                    </Hidden>
                    <StyledWrapper {...logoLinksSearchStyles.linksWrapper}>
                        <Zone contentId={id} zoneName="LeftLink" />
                        {/* {isSignedIn ? (
                            <Hidden below="md" {...logoLinksSearchStyles.linkListHidden}>
                                <Zone contentId={id} zoneName="MiddleLink" />
                            </Hidden>
                        ) : null} */}
                        <Hidden below="md" {...logoLinksSearchStyles.linkListHidden}>
                            {middleLinks?.map((link, index) => {
                                if (link.url && ((fields.middleLinks[index].fields.signedIn && isSignedIn) || !fields.middleLinks[index].fields.signedIn)) {
                                    const buttonStyle:LinkPresentationProps = {
                                        css: css`
                                            ${logoLinksSearchStyles?.middleLink?.css}
                                            ${themeButtonStyles({
                                                variant: fields.middleLinks[index].fields.variant,
                                                shape: "rounded",
                                                type: "solid",
                                            })}
                                        `,
                                        typographyProps: logoLinksSearchStyles?.middleLink?.typographyProps,
                                    }
                                    return (
                                        <Link
                                            key={`${link.url}.${link.title}`}
                                            href={link.url}
                                            target={fields.middleLinks[index].fields.openInNewWindow ? "_blank" : ""}
                                            {...logoLinksSearchStyles.middleLink}
                                            {...buttonStyle}
                                        >
                                            {fields.middleLinks[index].fields.overrideTitle || link.title}
                                        </Link>
                                    );
                                }
                                return null;
                            })}
                        </Hidden>
                        <Zone contentId={id} zoneName="RightLink" />
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
            {/* Poolcorp Custom Code */}
        </StyledWrapper>
    );
};

const logoLinksSearch: WidgetModule = {
    component: connect(mapStateToProps, null)(LogoLinksSearch), // Poolcorp Custom Code
    definition: {
        group: "Common",
        icon: "magnifying-glass",
        /* Poolcorp Custom Code */
        fieldDefinitions: [
            {
                name: fields.middleLinks,
                displayName: "Links",
                editorTemplate: "ListField",

                getDisplay: (item: HasFields, state) => {
                    const {
                        destination: { type, value },
                        overriddenTitle,
                    } = item.fields;
                    if (overriddenTitle) {
                        return overriddenTitle;
                    }
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return link?.title;
                    }
                    if (type === "Url") {
                        return value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: fields.destination,
                        displayName: "Destination",
                        editorTemplate: "LinkField",
                        allowCategories: item => false,
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isRequired: true,
                    },
                    {
                        name: fields.overrideTitle,
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: fields.openInNewWindow,
                        displayName: "Open In New Window",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                    {
                        name: fields.signedIn,
                        displayName: "Visible only to signed in customers",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                    {
                        name: fields.variant,
                        displayName: "Button Variant",
                        editorTemplate: "DropDownField",
                        options: [
                            { displayName: "Primary", value: "primary" },
                            { displayName: "Secondary", value: "secondary" },
                            { displayName: "Tertiary", value: "tertiary" },
                            { displayName: "quarternary", value: "quarternary" }, // Poolcorp Custom Code
                            { displayName: "quinary", value: "quinary" }, // Poolcorp Custom Code
                        ],
                        defaultValue: "primary",
                    },
                ],
            },
        ],
        /* Poolcorp Custom Code */
    },
};

export default logoLinksSearch;
